import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { mckeesportConfig } from "./data";

export default function McKeesportPage() {
  return <CityPageTemplate config={mckeesportConfig} />;
}